/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeightResponseDto
 */
export interface HeightResponseDto {
    /**
     * Identity of the Height observation
     * @type {string}
     * @memberof HeightResponseDto
     */
    observationId: string;
    /**
     * Height in feet
     * @type {number}
     * @memberof HeightResponseDto
     */
    feet: number;
    /**
     * Height in inches
     * @type {number}
     * @memberof HeightResponseDto
     */
    inches: number;
}

/**
 * Check if a given object implements the HeightResponseDto interface.
 */
export function instanceOfHeightResponseDto(value: object): value is HeightResponseDto {
    if (!('observationId' in value) || value['observationId'] === undefined) return false;
    if (!('feet' in value) || value['feet'] === undefined) return false;
    if (!('inches' in value) || value['inches'] === undefined) return false;
    return true;
}

export function HeightResponseDtoFromJSON(json: any): HeightResponseDto {
    return HeightResponseDtoFromJSONTyped(json, false);
}

export function HeightResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeightResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'observationId': json['observationId'],
        'feet': json['feet'],
        'inches': json['inches'],
    };
}

export function HeightResponseDtoToJSON(json: any): HeightResponseDto {
    return HeightResponseDtoToJSONTyped(json, false);
}

export function HeightResponseDtoToJSONTyped(value?: HeightResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'observationId': value['observationId'],
        'feet': value['feet'],
        'inches': value['inches'],
    };
}

